import React from 'react'
import { Modal, Row, Col, Card, Button } from 'react-bootstrap'
import { history } from '../../../../../_helpers/history'

export default function AddUserModal({
  show,
  handleClose,
}) {

  return (
    <Modal id="addUserModal" show={show} onHide={handleClose} size='lg'>
      <Modal.Header closeButton className='border-0 p-4'>
        <Modal.Title className='lead'>
          <Row>
            <Col xs='12'>Add User</Col>
          </Row>
          <Row>
            <Col xs='12'>
              <small className='font-weight-light'>
                Select the user type you would like to add.
              </small>
            </Col>
          </Row>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className='pt-1 px-4 pb-4'>
        <Row>
          <Col>
            <Card className='user-type-card '>
              <Card.Body className='d-flex flex-column justify-content-between'>
                <Row>
                  <Col>Licensed User</Col>
                </Row>
                <Row>
                  <Col className='font-weight-light'>
                    A licensed professional that renders care through telehealth appointment and is a provider designated on forms and intake.
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    <Button onClick={() => {
                      history.push('/account/users/add', { userType: 'Licensed' });
                    }} variant='success' block>Add Licensed User</Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className='user-type-card'>
              <Card.Body className='d-flex flex-column justify-content-between'>
                <Row>
                  <Col>Staff</Col>
                </Row>
                <Row>
                  <Col className='font-weight-light'>
                    A non-licensed professional that will not provide care through a telehealth appointment, but can send patient forms, schedule telehealth appointments, schedule events, and send direct messages to patients.
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    <Button onClick={() => {
                      history.push('/account/users/add', { userType: 'Staff' });
                    }}  variant='success' block>Add Staff User</Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}
